/*
 * fn: getHighlightNodes
 *
 * Searches a given value for a search term and highlights it if found with a <strong> tag
 *
 */
import { stripString } from '@/utils/commonUtil'

const getCleanedSearch = (input: string | undefined) => stripString(input).replace(/\s/g, '')

export const getHighlightNodes = (value: string, search: string) => {
  const searchClean = getCleanedSearch(search)
  if (!searchClean) return value

  const indices: number[] = []
  let valueKey = ''
  for (let i = 0; i < value.length; i++) {
    const key = getCleanedSearch(value.charAt(i))
    for (let j = 0; j < key.length; j++) indices.push(i)
    valueKey += key
  }

  const index = valueKey.indexOf(searchClean)
  if (index === -1) return value

  const start = indices[index] ?? 0
  const end = (indices[index + searchClean.length - 1] ?? start) + 1

  return (
    <>
      {value.slice(0, start)}
      <strong>{value.slice(start, end)}</strong>
      {value.slice(end)}
    </>
  )
}
